/**
 * Brand CTA colours.
 *
 * These are the three logo colours used for the primary homepage calls to
 * action. They are kept here rather than inline so the homepage hero, the
 * industry chooser and any future surface all stay on the same three.
 *
 * ## Accessibility note — read before changing
 *
 * Contrast against the text colour paired with each one, per WCAG 2.1:
 *
 *   CTA_PRIMARY  #1B93EA  with white text  → 3.27:1
 *   CTA_GREEN    #11C629  with DARK text   → 8.43:1
 *   CTA_GREEN    #11C629  with white text  → 2.26:1  (unacceptable — see below)
 *   CTA_PINK     #E5448D  with white text  → 3.76:1
 *
 * The green is the one to watch. At 2.26:1, white text on #11C629 is effectively
 * unreadable, so CTA_GREEN_TEXT is deliberately the dark navy rather than white.
 * Do not "harmonise" it to white.
 *
 * Blue (3.27:1) and pink (3.76:1) clear the WCAG AA threshold for LARGE text
 * (3:1) but not for normal text (4.5:1). The buttons they style are `size="lg"`
 * with `font-bold`, which qualifies as large text. If a label is ever shortened
 * to a non-bold or small size, re-check the ratio.
 */
export const CTA_PRIMARY = '#1B93EA';
export const CTA_PRIMARY_HOVER = '#1683D2';

export const CTA_GREEN = '#11C629';
export const CTA_GREEN_HOVER = '#0FB224';
/** Dark navy — NOT white. See the note above. */
export const CTA_GREEN_TEXT = '#00113F';

export const CTA_PINK = '#E5448D';
export const CTA_PINK_HOVER = '#CE3A7E';

export const WHATSAPP_NUMBER = '27774584896';
export const WHATSAPP_MESSAGE =
  "Hi Zamzi Connect, I'd like to get my business found on Google and AI.";
